export default function DevisesConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('devises');
}

DevisesConfiguration.$inject = ['$translatePartialLoaderProvider'];
